<template>
  <div class="box">
    <div
      class="c-f-ar bt"
      @click="cusClick"
    >{{t || title}}</div>
  </div>
</template>

<script>
export default {
  name: "GHello",
  props: {
    title: {
      type: String,
      default: '',
    },
    t: {
      type: String,
      default: '',
    }
  },
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    cusClick() {
      this.$emit('click');
    }
  }
};
</script>
<style scoped lang='scss'>
.box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
.bt {
  background: var(--tc);
  color: #fff;
  height: 96px;
  box-sizing: border-box;
  font-size: 34px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
}

</style>
